export class SelectToTabs {

    private options;
    private allButton;

    constructor (private select:JQuery<HTMLElement>) {
        this.select.addClass('select-to-tabs-widget');
        this.options = this.select.find('.select-option');

        //allButton
        this.allButton = $('<a/>');
        this.allButton.addClass('all-options-button');
        this.allButton.text('Alle');

        //append/prepend
        //this.options.parent().prepend(this.allButton);

        this.allButton.click(() => {
            this.selectAll();
            this.select.closest('form').find('[type="submit"]').click();
        });

        this.options.on('pointerdown', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            this.unselectAll();

            let value = $(ev.target).data('value');
            this.select.val([value]);

            let select = this.select.find('select');
            select.find('option[value=' + value + ']').prop('selected', 'selected');
            select.find('option[value=' + value + ']').addClass('selected');

            select.trigger('change');
            this.select.closest('form').find('[type="submit"]').click();

            this.allButton.removeClass('selected');
        });
    }

    private selectAll() {
        //console.log('selectAll');
        let select=this.select.find("select");
        let options = select.find('option');

        //console.log(options);

        for (let option of options) {
            $(option).addClass('selected');
            $(option).prop('selected', 'selected');
        }

        this.allButton.addClass('selected');

        select.trigger('change');
    }

    private unselectAll() {
        let select=this.select.find("select");
        let options = select.find('option');

        for (let option of options) {
            $(option).removeClass('selected');
            $(option).prop('selected', '');
        }

        this.allButton.addClass('');

        select.trigger('change');
    }
}

export {};